<template>
  <div class="cs-off-canvas">
    <div class="cs-off-canvas-sidebar" :style="[sidebarStyles]">
      <slot name="sidebar"></slot>
    </div>
    <div class="cs-off-canvas-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: Boolean,
    sidebarWidth: {
      type: Number,
      default() {
        return 300;
      },
    },
  },
  data() {
    return {
      shown: false,
    };
  },
  computed: {
    sidebarStyles() {
      return {
        width: `${this.sidebarWidth}px`,
        marginLeft: this.shown ? '0px' : `-${this.sidebarWidth}px`,
      };
    },
  },
  watch: {
    value(val) {
      this.shown = val;
    },
    shown(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="sass" scoped>
  .cs-off-canvas
    width: 100%
    height: 100vh
    display: flex

  .cs-off-canvas-sidebar
    flex: none
    transition: all 0.3s ease-in 0s

  .cs-off-canvas-content
    flex: 1
</style>
